import { useState } from 'react';
import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Checkbox } from '@components/Checkbox';
import TableCellCheckbox from './TableCellCheckbox';
import { renderCellContent } from './renderCellContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { TABLE_BODY_CELL_HEIGHT, TABLE_BODY_CELL_PADDING } from './tableLayout';
import { guardedRowClick } from './rowClick';

const TableCellStyled = styled(TableCell)(() => ({
    padding: TABLE_BODY_CELL_PADDING,
    minHeight: TABLE_BODY_CELL_HEIGHT,
    height: TABLE_BODY_CELL_HEIGHT,
    '& .MuiIconButton-root': {
        padding: 8,
        '&:not(:first-of-type)': {
            marginLeft: 16,
        },
        '& svg': {
            color: 'var(--text-secondary)',
            width: 20,
            height: 20,
        },
    },
}));
const TableCellCollapsible = styled(TableCell)(() => ({
    padding: 0,
    border: 'none',
    backgroundColor: 'var(--action-hover)',
}));

const TableRowStyled = styled(TableRow)(() => ({
    '&.MuiTableRow-hover:hover': {
        background: 'var(--action-highlight)',
    },
}));

const TableRowPlain = ({
    rowData,
    dataRow,
    hover = false,
    withCheckbox,
    checked,
    onSelect,
    onClick,
    collapsibleRow,
    isCollapsible,
    colSpan,
    withTotalRow,
    isLastRow,
}) => {
    const [open, setOpen] = useState(false);
    const rowAction =
        isCollapsible || onClick
            ? () => {
                  if (isCollapsible) {
                      setOpen(!open);
                  }
                  onClick?.();
              }
            : undefined;

    return (
        <>
            <TableRowStyled
                data-row={dataRow}
                hover={hover}
                sx={onClick ? { cursor: 'pointer' } : undefined}
                onClick={guardedRowClick(rowAction)}
            >
                {isCollapsible && (
                    <TableCellStyled align="center">
                        {!(withTotalRow && isLastRow) && (
                            <IconButton
                                onClick={e => {
                                    e.stopPropagation();
                                    setOpen(!open);
                                }}
                            >
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        )}
                    </TableCellStyled>
                )}
                {withCheckbox && (
                    <TableCellCheckbox>
                        <Checkbox checked={checked} onChange={onSelect} />
                    </TableCellCheckbox>
                )}
                {rowData?.length &&
                    rowData.map((cell, position) => (
                        <TableCellStyled
                            align={cell?.align || (position === 0 ? 'left' : 'center')}
                            component="th"
                            scope="row"
                            key={cell?.value || `row-cell-${position}`}
                            width={cell.width || 0}
                            sx={cell?.sx}
                            title={cell?.title}
                            onClick={cell?.onClick}
                        >
                            {renderCellContent(cell)}
                        </TableCellStyled>
                    ))}
            </TableRowStyled>
            {isCollapsible && !(withTotalRow && isLastRow) && (
                <TableRowStyled>
                    <TableCellCollapsible component="th" scope="row" colSpan={colSpan}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {collapsibleRow}
                        </Collapse>
                    </TableCellCollapsible>
                </TableRowStyled>
            )}
        </>
    );
};

export default TableRowPlain;
